/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import type * as Types from '@sg/graphql-schema';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrderPaymentStateQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
  orderType: Types.Scalars['String']['input'];
}>;

export type OrderPaymentStateQuery = {
  readonly __typename?: 'Query';
  readonly orderPaymentState: {
    readonly __typename: 'OrderPaymentState';
    readonly id: string;
    readonly paymentIntentId: string;
    readonly paymentIntentSecret: string;
    readonly status: Types.OrderPaymentStatus;
    readonly error: string | null;
    readonly updatedAt: string;
  } | null;
};

export const OrderPaymentStateDocument = gql`
  query OrderPaymentState($orderId: String!, $orderType: String!) {
    orderPaymentState(orderId: $orderId, orderType: $orderType) {
      id
      paymentIntentId
      paymentIntentSecret
      status
      error
      updatedAt
      __typename
    }
  }
`;

export function useOrderPaymentStateQuery(
  options: Omit<Urql.UseQueryArgs<OrderPaymentStateQueryVariables>, 'query'>,
) {
  return Urql.useQuery<OrderPaymentStateQuery, OrderPaymentStateQueryVariables>(
    { query: OrderPaymentStateDocument, ...options },
  );
}
